import gql from 'graphql-tag';

export const updateServiceRequestStatusByIdMutation = gql`
  mutation updateServiceRequestStatusByIdMutation(
    $id: String!
    $status: String!
  ) {
    updateServiceRequestStatusById(id: $id, status: $status)
  }
`;
